module.exports = __webpack_public_path__ + "assets/img/05.22c3ad5f.jpg";